import axios, { AxiosInstance, CancelTokenSource, InternalAxiosRequestConfig } from 'axios';

const GEN_PDF_URL = import.meta.env.VITE_GEN_PDF_URL;
const ExternalAxios: AxiosInstance = axios.create({
  baseURL: `${GEN_PDF_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

const requests: { [requestName: string]: CancelTokenSource | undefined } = {};

ExternalAxios.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (config.url && (config.method === 'get' || config.method === 'GET')) {
      if (requests[config.url]) {
        requests[config.url]?.cancel('AxiosService: Cancelling previous request!');
      }

      requests[config.url] = axios.CancelToken.source();
      config.cancelToken = requests[config.url]?.token;
    }

    return config;
  },
);

export { ExternalAxios };
